import { useContext } from "react";
import { StoresContext } from "../contexts/stores";

export const useStores = () => useContext(StoresContext);
